

export default function searchForm() {
    const searchFormBtn = document.querySelector('.page-header__search-toggle');

    const searchForm = document.querySelector('.page-header__search-form');

    let formOpen = false;

    if (searchFormBtn && searchForm) {
        searchFormBtn.addEventListener('click', () => {
            if (!formOpen) {
                searchFormBtn.classList.add('active');
                searchForm.classList.add('shown')

                formOpen = true;
            } else {
                searchFormBtn.classList.remove('active');
                searchForm.classList.remove('shown')
               
                formOpen = false;
            }
        });
    }
}
